import template from './skills_competency_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class SkillsCompetencyHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
}

class SkillsCompetencyHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new SkillsCompetencyHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'SkillsCompetencyHelp',
	dialog_class: SkillsCompetencyHelpPage,
	template: template,
	provider: 'ps'
};
